import EventBanner from "../../../public/banners/mya_3d_banner.jpg";
import MyaCalendarImg from "../../../public/events/mya-3d/mya_3d_calendar.jpg";
import MyaLocationImg from "../../../public/events/mya-3d/mya_3d_location.jpg";

export default {
  date: "28-10-2022",
  title: "來自香港的人氣Vtuber——米亞Mya，籌備已久的3D化即將完成﹗",
  description:
    "來自香港的人氣Vtuber——米亞Mya，籌備已久的3D化即將完成，就此有各種慶祝活動及抽獎送禮。",
  images: { MyaCalendarImg, MyaLocationImg },
  mainImage: EventBanner,
  mdContent: `
來自香港的人氣Vtuber——米亞Mya，籌備已久的3D化即將完成，就此有各種慶祝活動及抽獎送禮。

米亞Mya日前於直播上公佈由約150名粉絲眾籌的3D化的工程迎來了尾聲，為了感謝各位的支持，在3D化完成後的2-3月內會有禮物送給大家。

而3D化的模組會在10月29日晚上9時於米亞的Youtube頻道公佈，同時會舉行Mini Live，詳情的Mini Live內容仍然未知，但是米亞Mya似乎準備了不少意想不到的驚喜給觀眾，除了表演之外大概還有更多勁爆的資訊將會被公開，目前只知道的內容就是米亞Mya根據數月前向觀眾調查對於3D化的意見和看法去安排節目內容，各位想知道自己的心聲是否有被聽到，就記得打開Youtube的通知，到時候準時收看直播喇。

米亞Mya還公佈了10月24日至30日慶祝週的行程表，接下來為大家介紹一下活動內容。

---

![米亞3D化慶祝週日程](MyaCalendarImg)

### 10月25日：最佳米亞直播﹗回顧企劃

故名思意，這天的活動就是回看米亞Mya一路以來的直播中的精華片段，精華片段就是由各位粉絲一起選出來，米亞Mya篩選過後會在直播中跟觀眾一起選出最好的片段。
至於要如何投稿呢﹖大家可以透過以下的連結投稿。

**投稿連結：<https://forms.gle/dmUgA8gBR1fG8c3k9>**

輸入影片連結以及標上時間，並附上提名的原因就完成了。
如果有幸被米亞Mya選中的話還有機會獲得禮物。

另外粉絲還可以在上述連結中提出希望米亞Mya以3D化的模樣做出什麼動作、說什麼經典對白或台詞，例如「你同我出黎隻揪﹗(你給我出來單挑﹗)」，但注意要在十秒內可以完成的喔。

---

### 10月26日：甘米的爛手工台

這天米亞Mya的主人——甘米也會出現在直播中，造一些手工藝並以抽獎的形式送給大家。 甘米甚少會出現在直播中，要米亞Mya千辛萬苦求她才會願意露面，所以大家一定不可以錯過喔。
至於她的手工藝會有多「爛」，也請大家好好期待一下吧﹗

---

### 10月27日：尋找米亞足跡~初配信歌回﹗

這活動的關鍵字就是「#米亞3D化」﹗
大家可以於IG、Twitter等等的社交平台發佈一些3D化的賀圖或感想，然後再加上「#米亞3D化」。
除了賀圖感想，大家還可以發佈跟米亞Mya的合照呢﹗

在10月22日至28日，於香港港鐵油麻地站C出口，會有米亞Mya的廣告燈牌展示﹗

![地鐵站燈牌打卡處﹗ @油麻地站 C出口](MyaLocationImg)

米亞如此精心準備，請大家務必要前往打卡﹗

就此活動，米亞Mya有些注意點告訴大家：

1. 打卡時盡量要小心留意人流，如果為了打卡造成阻塞， 引致「因為Vtuber米亞的廣告燈牌吸引大批粉絲打卡阻塞通道」等等的聲音出現就不好了~
2. 如果見到疑似甘米或米亞本人的話，請保持冷靜，不要尖叫或怪笑，上前相認的話對方會裝傻不承認。
3. 加上「#米亞3D化」的投稿將有機會出現在直播中，如果大家不想在直播中露臉，請記得在自己的臉上打馬賽克。

---

### 10月29日：米亞3D化演唱會﹗各種重大發表

這天就是萬眾期待的Mini Live，請大家預留約2小時的時間觀看直播。

記得是晚上9時開始﹗

記得是晚上9時開始﹗

記得是晚上9時開始﹗

打開直播的通知鈴鐺就不怕錯過了﹗

<iframe src="https://www.youtube.com/embed/bZ1ZUSn5de0" title="【#米亞3D化】我是、香港虛擬偶像米亞🐼！3D化發佈 Mini Live ＆ 各種重大發表💖！【米亞Mya】" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

<figcaption>直播待機室 (YouTube)</figcaption>

---

### 10月30日：3D化感想分享&感謝日

這天米亞會就3D化和慶祝週發表各種感想和對粉絲的支持作出感謝，粉絲投稿的信、應援話語也被在直播被米亞讀出，
慶祝週的最後一天，也希望大家不要缺席喔﹗

在這重大預告的直播中，米亞全程都十分興奮，看得出她對於3D化有多期待和高興，各位米亞的粉絲請多多支持，一起見證米亞重大的里程碑﹗

<iframe src="https://www.youtube.com/embed/eG0af0aPBLI" title="【重大預告📢】3D化日期公開🎉！＆登上地鐵站燈牌🎉！＆慶祝活動預告🎉！【米亞Mya】" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
<figcaption>米亞 Mya 3D化預告直播 (YouTube)</figcaption>
`,
  mdInfo: `
# 活動連結

**米亞 Mya YouTube channel <https://www.youtube.com/c/gummy_forest>**
**米亞 Mya 3D化預告直播 <https://youtu.be/eG0af0aPBLI>**
`,
};
